import Link from "next/link";
import React, { useCallback, useEffect, useState ,useMemo} from "react";
import { Button, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { webServiceClient } from "../../data/apiClient";
const MySwal = withReactContent(Swal);
import { GoogleReCaptchaProvider,  useGoogleReCaptcha } from "react-google-recaptcha-v3";
import useTrait from "../Common/syncUpdateState";
const showAlert = (error) => {
  MySwal.fire({
    title: "Error Occured!",
    text: error,
    icon: "error",
    timerProgressBar: false,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: "Close",
  });
};

const RegoSearchComponent = ({ state, regoOrVin}) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const country = isAU ? "au" : "nz";
  state = !isAU ? "NZ" : state;
  const [isLoaded, SetLoaded] = React.useState(false);
 // const [recaptchaResponse, setRecaptchaResponse]=React.useState();
  const [currentState, setCurrentState] = useState(state);
  const [regoNumber, setRegoNumber] = useState("");
  const [vinNumber, setVinNumber] = useState("");
  const [searchResult, setSearchResult] = useState();
  const apiService = webServiceClient(SetLoaded);
 
  const googleCaptchaReload=useTrait();
  const recaptchaResponse=useTrait();
  // const { executeRecaptcha } = useGoogleReCaptcha();
  const isRecaptchaLoading= useTrait(false);
  // const isRecaptchaReload=useTrait(false);
 
  const doRegoSearch = async (state, rego) => {
      try {
       // await  isRecaptchaLoading.set(true);
        setSearchResult(null);
        // if(!recaptchaResponse&&!googleCaptchaReload.get()){
        //  await googleCaptchaReload.set(true);
        // }
        const localState = !isAU ? "NZ" : state;
        
        const token=await executeRecaptcha("regoSearch");
        const resp = await apiService.regoSearch(state, rego, token);
        setSearchResult(resp.data.vrqResult);
        if (resp.data.vrqResult.length === 0) {
          showAlert(`Sorry no matching vehicle found for ${rego}/${state}`);
        }
      } catch (err) {
        // console.log(err);
        await showAlert("Unexpected error occured doing Rego search");
      }
    };

   const getVinApi= async(vin)=>{

      // if(recaptchaResponse){
        await  isRecaptchaLoading.set(true);
        //   }
          
        // else{
        // await  googleCaptchaReload.set(true);
        // }
        const token=await executeRecaptcha("regoSearch");
        const resp = await apiService.vinSearch(vin,token);
        return resp;
    }

  const doVinSearch = async (vin) => {
      try {
     
        setSearchResult(null);
        // if(!recaptchaResponse&&!googleCaptchaReload.get()){
        //   await googleCaptchaReload.set(true);
        //  }
       // debugger;
        
        const resp = await getVinApi(vin);
        setSearchResult(resp.data?.vrqResult);
        if (resp.data?.vrqResult?.length === 0 || resp.data === null) {
          showAlert(`Sorry no matching vehicle found for VIN ${vin}`);
        }
      } catch (err) {
         //console.log(err);
        showAlert("Unexpected error occured doing VIN search");
      }
    };

  useEffect(() => {
   
    if (state === "-") {
    } else if (state.toUpperCase() === "VIN") {
      if (regoOrVin !== "-") {
        setVinNumber(regoOrVin);
        doVinSearch(regoOrVin);
      }
    } else {
      setCurrentState(state);
      if (regoOrVin !== "-") {
        setRegoNumber(regoOrVin);
        doRegoSearch(state, regoOrVin);
      }
    }
}, []);

  const handleRegoNoChange = (event) => {
    setRegoNumber(event.target.value);
  };

  const handleVinChange = (event) => {
    setVinNumber(event.target.value);
  };

  const handleStateChange = (event) => {
    setCurrentState(event.target.value);
  };

  const submitForm = async  (event) => {
    event.preventDefault();
   
    if (
      regoNumber !== "" &&
      currentState !== "-" &&
      currentState !== "Select State" &&
      !isLoaded 
    ) {
     
      doRegoSearch(currentState, regoNumber);
    } else if (vinNumber !== "" && !isLoaded) {
      doVinSearch(vinNumber);
    } else {
      showAlert("Please enter rego & state or do a vin search");
    }
  };

  return (
    <>
      <form onSubmit={submitForm}>
        <div className='row g-2'>
          <div className='col-sm-6'>
            <div className='row g-2'>
              <div className='col'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Rego no.'
                  value={regoNumber}
                  onChange={handleRegoNoChange}
                />
              </div>
              <div className='col-sm-6'>
                {isAU && (
                  <select
                    className='form-select'
                    required=''
                    name='regoStateAU'
                    id='regoStateAU'
                    value={currentState}
                    onChange={handleStateChange}
                  >
                    <option>Select State</option>
                    <option value='NSW'>NSW</option>
                    <option value='ACT'>ACT</option>
                    <option value='VIC'>VIC</option>
                    <option value='SA'>SA</option>
                    <option value='WA'>WA</option>
                    <option value='NT'>NT</option>
                    <option value='QLD'>QLD</option>
                    <option value='TAS'>TAS</option>
                    <option value='NHV'>National Heavy Vehicle</option>
                  </select>
                )}
                {!isAU && (
                  <select
                    className='form-select'
                    required=''
                    name='regoStateAU'
                    id='regoStateAU'
                    value={currentState}
                    onChange={handleStateChange}
                  >
                    <option value='NZ'>NZ</option>
                  </select>
                )}
              </div>
            </div>
          </div>
          <div className='col-sm-6'>
            <div className='row g-2'>
              <div className='col d-flex align-items-center justify-content-center accessibility-text'>
                OR
              </div>
              <div className='col-sm-8'>
                <input
                  type='text'
                  className='form-control mb-2 mr-sm-2'
                  id='inlineFormInputName2'
                  placeholder='VIN No.'
                  value={vinNumber}
                  onChange={handleVinChange}
                />
              </div>
              <div className='col-sm-3'>
                <Button
                  type='submit'
                  variant='primary'
                  className='mb-2 w-100'
                  disabled={isLoaded}
                >
                  {isLoaded && (
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                    />
                  )}
                  {!isLoaded && "Search"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div className='container'>
        {searchResult != null && searchResult.length > 0 && (
          <div>
            <table className='table table-condensed table-striped'>
              <thead>
                <tr>
                  <td colSpan='2'>Matching Vehicles:</td>
                </tr>
              </thead>
              <tbody>
                {searchResult.map(function (field, index) {
                  return (
                    <tr key={index}>
                      <td>
                        <Link href={`/results/${field.vehicleIdEncrypted}`} legacyBehavior>
                          <a className='btn'>{field.vehicleLongDescription}</a>
                        </Link>
                      </td>
                      <td>
                        <Link href={`/results/${field.vehicleIdEncrypted}`} legacyBehavior>
                          <a className='btn btn-success'>Select</a>
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default RegoSearchComponent;
